<template>
  <!-- 公共弹窗，不可用游戏弹窗 -->
   <div>
    <van-popup
      v-model:show="props.showGame"
      round
      position="bottom"
      class="geme_notAllow"
      :style="{ height: '70%' }"
    
      closeable
      @close="onClose"
      @open="openPop"
    >
      <h3>优惠券使用范围</h3>
      <div class="search">
        <input
          type="text"
          v-model="state.gamename"
          placeholder="输入游戏名查询"
        />
        <span @click="gameSearch">搜索</span>
      </div>
      <h4>{{ state.type == 0 ? `近期在玩的游戏`:`搜索的结果` }}</h4>
      <p>优惠券适用于大部分0.1/0.05折游戏</p>
      <div class="gameList">
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-grid :gutter="8" :border="false" :center="false">
            <van-grid-item
              v-for="(item, i) in state.gameList"
              :key="i + '-list'"
            >
              <template #default>
                <div class="imgbox" :class="{'uncheck': !item.isAvailable}">
                    <div class="imgbox-content">
                      <img :src="item.pic1" alt="" />
                    </div>
                    
                    <div v-if="item.isAvailable" class="ky">可用</div>
                    <div v-else class="bky">不可用</div>
                </div>
                
                <h4>{{ item.gamename }}</h4>
                <p v-show="item.name_sub">{{ item.name_sub }}</p>
              </template>
            </van-grid-item>
          </van-grid>
        </van-list>
      </div>
    </van-popup>
   </div>

</template>

<script setup>
import { reactive, computed, watch } from 'vue';
import { monthCardNoGame } from "@/api/yzuser";
import { juanbaoGames, mygame, usersJuanbaoGames } from '../../api/user';
import { getToken } from '../../utils/auth';
import { getQueryString } from '../../utils/location';

// 定义props，接收弹窗显示控制
const props = defineProps({
  showGame: {
    type: Boolean,
    required: true
  }
});

// 定义emits，向外部派发事件
const emits = defineEmits(['update:showGame', 'close']);

// 内部控制的弹窗显示，和props同步
const innerShowGame = computed({
  get() {
    return props.showGame;
  },
  set(val) {
    emits('update:showGame', val);
  }
});

const state = reactive({
  loading: false,
  finished: false,
  gameList: [],
  gamename: "",
  type: 0, // 0:最近游戏 1:所有游戏
});

// 保证分页变量响应式且适用于多次调用
let pagecode = 0;
let fetchFlag2 = false;

const openPop = async () => {
  pagecode = 1;
  state.gameList = [];
  state.finished = false;
  state.loading = true;
  state.type = 0;
  await onSearchGameWithType();
};

const onClose = () => {
  emits('update:showGame', false);
  emits('close');
  // 可根据业务需要清空数据或保留
};

const gameSearch = () => {
  state.gameList = [];
  pagecode = 0;
  state.finished = false;
  state.type = 1;
  onLoad();
};

const onLoad = async () => {
  pagecode++;
  await onSearchGameWithType();
};

const onSearchGameWithType = () => {
  if (state.type == 0) {
    getRecentGameList();
  } else {
    getGameList();
  }
}

const getGameList = async () => {
  if (fetchFlag2) return;
  fetchFlag2 = true;

  try {
    let res = await juanbaoGames({
      pagecode: pagecode,
      keyword: state.gamename,
    });
    if (res.data.code == 1) {
      state.gameList = state.gameList.concat(res.data.data.lists);
      if (pagecode >= res.data.data.total_page) {
        state.finished = true;
      }
    } else {
      state.finished = true;
      state.loading = false;
    }
    state.loading = false;
  } catch (error) {
    state.finished = true;
    state.loading = false;
  }
  fetchFlag2 = false;
};

const getRecentGameList = async () => {
  if (fetchFlag2) return;
  fetchFlag2 = true;

  try {
    let res = await usersJuanbaoGames({
      pagecode: pagecode,
      uid: getQueryString("uid")
    });
    if (res.data.code == 1) {
      state.gameList = state.gameList.concat(res.data.data.lists);

      if (pagecode >= res.data.data.total_page) {
        state.finished = true;
      }
      if(pagecode == 1){
        if(res.data.data.lists.length <= 0){
            state.gameList = [];
            pagecode = 0;
            state.finished = false;
            state.type = 1;
            onLoad();
        }
      }


    } else {
      state.finished = true;
      state.loading = false;
      
      if(pagecode == 1){
        state.gameList = [];
        pagecode = 0;
        state.finished = false;
        state.type = 1;
        onLoad();
      }
    }
    state.loading = false;
  } catch (error) {
    state.finished = true;
    state.loading = false;
  }
  fetchFlag2 = false;
};

// 外部显隐变化后，若showGame=true自动刷新
watch(
  () => props.showGame,
  (v) => {
    if (v) {
      openPop();
    }
  }
);
</script>

<style scoped="scoped">

/* 不可用游戏弹窗 */
:deep(.geme_notAllow) {
  padding: 32px;
  color: #333;
  display: flex;
  flex-direction: column;
}
:deep(.geme_notAllow) h3 {
  text-align: center;
  margin-bottom: 32px;
}
:deep(.geme_notAllow) .search input {
  border: none;
  width: 590px;
  height: 88px;
  background: #f7f7f7;
  border-radius: 198px;
  padding-left: 32px;
  margin-right: 32px;
  color: #333;
}
:deep(.geme_notAllow) .search span {
  font-size: 32px;
  color: #333;
}
:deep(.geme_notAllow) > h4 {
  margin: 32px 0 12px 0;
  font-size: 32px;
}
:deep(.geme_notAllow) > p {
  font-size: 20px;
  color: #999;
  margin-bottom: 28px;
}
:deep(.geme_notAllow) .gameList {
  flex: 1;
  overflow: auto;
}
:deep(.geme_notAllow) .gameList .van-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
:deep(.geme_notAllow) .gameList .van-cell {
  width: 142px;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 20px;
}
:deep(.geme_notAllow) .gameList .van-cell__value {
  display: flex;
  flex-direction: column;
}

:deep(.van-grid-item__content) {
  width: 148px;
  white-space: nowrap;
  align-items: center;
  padding-bottom: 24px;
  background-color: #fff;
}
:deep(.geme_notAllow) .gameList .imgbox {
    width: 120px;
    height: 120px;
    border-radius: 28px;
    position: relative;
    overflow: hidden;
    background-color: #00D9C5;
}
:deep(.geme_notAllow) .gameList .imgbox.uncheck {
    background-color: #999999;
}
:deep(.geme_notAllow) .gameList .imgbox-content {
  width: 112px;
  height: 112px;
  border-radius: 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:deep(.geme_notAllow) .gameList .imgbox-content img {
  width: 100%;
  height: 100%;
}
:deep(.geme_notAllow) .gameList .ky {
  width: 64px;
  height: 32px;
  position: absolute;
  bottom: 0;
  right: 0;
  border-top-left-radius: 28px;
  border-bottom-right-radius: 28px;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 32px;
  z-index: 100;
  background-color: #00D9C5;
}
:deep(.geme_notAllow) .gameList .bky {
  width: 80px;
  height: 32px;
  position: absolute;
  bottom: 0;
  right: 0;
  border-top-left-radius: 28px;
  border-bottom-right-radius: 28px;
  color: white;
  font-size: 16px;
  text-align: center;
  line-height: 32px;
  z-index: 100;
  background-color: #999999;
}


:deep(.geme_notAllow) .gameList h4 {
  font-size: 28px;
  margin: 12px 0 4px 0;
  width: 142px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
:deep(.geme_notAllow) .gameList p {
  max-width: 142px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 8px;
  font-size: 20px;
  color: #666666;
  background: #f3f4f8;
  border-radius: 6px;
}
:deep(.game_notAllow) .van-list__finished-text {
  position: absolute;
}

/* 加载框 */
.allContent :deep(.load-overlay) {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
